<template>
  <section>
    <v-row class="d-flex justify-content-center ben_main" no-gutters>
      <v-col col sm="12" md="12" lg="12">
        <v-stepper v-model="currentStep">
          <div class="white--text d-flex justify-space-between color pa-2">
            <div>
              <span class="text-h6 ms-2 mt-2">Beneficiary</span>
            </div>
            <div>
              <v-btn fab small color="white" @click="closeDialog">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
          <v-stepper-header>
            <v-stepper-step :complete="currentStep > 1" step="1">{{
              $t("bankDetails")
            }}</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="currentStep > 2" step="2">{{
              $t("basicDetails")
            }}</v-stepper-step>

            <v-divider></v-divider>
            <v-stepper-step :complete="currentStep > 3" step="3">{{
              $t("summary")
            }}</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <account-type
                :beneficiaryReqBody="beneficiaryReqBody"
                :bene_country_name="bene_country_name"
                :recieverDetails="getrecieverDetails"
                @onClickNext="onClickNext"
                @onClickBack="onClickBack"
              />
            </v-stepper-content>
            <v-stepper-content step="2">
              <basic-details
                :beneficiaryReqBody="beneficiaryReqBody"
                :bene_country="bene_country_name"
                :recieverDetails="getrecieverDetails"
                :payment_method_selected="payment_method_selected"
                @onClickNext="onClickNext"
                @onClickBack="onClickBack"
              />
            </v-stepper-content>

            <v-stepper-content step="3">
              <Summary
                :beneficiaryReqBody="beneficiaryReqBody"
                :loader="loader"
                @onClickNext="onCreateBeneficiary"
                @onClickBack="onClickBack"
              ></Summary>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import AccountType from "@/components/BeneficiaryPage/AccountType/index.vue";
import BasicDetails from "@/components/BeneficiaryPage/BasicDetails/index.vue";
import Summary from "@/components/BeneficiaryPage/Summary/index.vue";
import remmitenceService from "@/services/RemitteService/remitteService.js";
import alerts from "@/mixins/alerts";
export default {
  mixins: [alerts],
  name: "Beneficiary",
  components: {
    AccountType,
    BasicDetails,
    Summary,
  },
  props: {
    cust_id: String,
    getrecieverDetails: {
      type: Object,
    },
  },
  data() {
    return {
      steps: [
        { text: this.$t("accountType") },
        { text: this.$t("basicDetails") },
        { text: this.$t("bankDetails") },
      ],
      currentStep: 1,
      loader: false,
      beneficiaryReqBody: {
        payment_mode_name: "",
        rec_type: "IND",
        country_name: "",
        country_code: "",
        currency_code: "",
        payment_code: "",
        branch_code: "",
        branch_id: 0,
        bank_id: 0,
        bank_name: "",
        bank_account_no: null,
        location_id: "",
        location_name: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        last_name2: "",
        relationship_code: "",
        relationship_name: "",
        phone_number: "",
        mobile_number: "",
        address: "",
        state_code: "",
        state_name: "",
        district_code: "",
        city_code: "",
        city_name: "",
        postal_code: "",
        policy_number: "",
        email_id: null,
        id_no: "",
        id_type: "",
      },
      bene_country_name: "",
      payment_method_selected: "",
    };
  },

  methods: {
    closeDialog() {
      this.$emit("closeDialog", false);
      this.$store.state.showDialog = false;
      this.currentStep = 1;
    },
    onClickNext() {
      this.currentStep++;
      console.log("this.beneficiaryReqBody", this.beneficiaryReqBody);
      this.bene_country_name = this.beneficiaryReqBody.country_name;
      this.payment_method_selected = this.beneficiaryReqBody.payment_mode;
    },
    onClickBack() {
      this.currentStep--;
    },
    async onCreateBeneficiary() {
      console.log(" this.beneficiaryReqBody", this.beneficiaryReqBody);
      try {
        this.loader = true;
        let responseData;
        if (this.getrecieverDetails.receiver_id) {
          responseData = await remmitenceService.updateBenificiaryData(
            this.getrecieverDetails.receiver_id,
            this.$route.query.id,
            this.beneficiaryReqBody
          );
        } else {
          responseData = await remmitenceService.saveBenificiaryData(
            this.$route.query.id,
            this.beneficiaryReqBody
          );
        }

        if (responseData && responseData.data.status_code == 200) {
          this.loader = false;
          this.showAlertSuccess(responseData.data.message);

          this.$emit("closeDialog", false);
          this.$emit("getBenficiary");
        } else {
          this.loader = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (error) {
        this.loader = false;
        console.log(error);
        this.showAlertError("Something went wrong please try again later.");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
::v-deep ul {
  list-style-type: none !important;
}
::v-deep h4 {
  color: $txt;
  text-align: center;
}
.btn-light {
  font-weight: bold;
  color: $dimgrey;
  background: $white;
  margin: 0 5px;
  &:not(:disabled) {
    &:not(.disabled).active {
      color: $secondary;
    }
    &:not(.disabled) {
      &:active {
        color: $secondary;
      }
    }
  }
  &:hover {
    border: 1px solid red !important;
    color: $dimgrey;
    background: $white;
  }
}
.card {
  border: none;
}
::v-deep label {
  color: $lightslategrey !important;
  margin-bottom: 0 !important;
}
::v-deep .btn-light {
  border: 1px solid $lightgrey !important;
}
.color {
  background-color: $secondary;
}
.floating-placeholder-name {
  color: red;
  margin-top: -12px;
  font-size: 14px;
  text-align: -webkit-left;
}
.color-error {
  background-color: rgb(240, 50, 50);
}
</style>
